// extracted by mini-css-extract-plugin
export default {"instruction":"Instruction-module--instruction--e0ad0","caret":"Instruction-module--caret--558c5","content":"Instruction-module--content--6bad1"};